"use client";

import { Share2 } from "lucide-react";
import { useEffect, useState } from "react";
import {
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  TelegramIcon,
  TelegramShareButton,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
  XIcon,
} from "react-share";

type Props = {
  title: string;
  top?: boolean;
};

const ShareObituary = ({ title, top }: Props) => {
  const [url, setUrl] = useState<string>("");

  const [showShare, setShowShare] = useState(false);

  const toogleShare = () => {
    setShowShare(!showShare);
  };

  useEffect(() => {
    if (window) {
      setUrl(window.location.href);
    }
  }, []);

  return (
    <div
      className={`absolute -right-2 ${
        top ? "top-14" : "-top-1"
      } flex w-10 flex-col items-start justify-center gap-1 lg:-top-1`}
    >
      <div
        className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-full bg-white text-secondary shadow-lg"
        onClick={() => {
          toogleShare();
        }}
      >
        <Share2 className="mr-0.5 h-5 w-5" />
      </div>
      {showShare && (
        <div className="flex w-10 flex-col gap-1 rounded-3xl bg-white p-1.5 shadow-lg">
          <FacebookShareButton
            url={url}
            // className="Demo__some-network__share-button"
          >
            <FacebookIcon size={32} round />
          </FacebookShareButton>

          <TwitterShareButton
            url={url}
            title={title}
            // className="Demo__some-network__share-button"
          >
            <XIcon size={32} round />
          </TwitterShareButton>

          <TelegramShareButton url={url} title={title}>
            <TelegramIcon size={32} round />
          </TelegramShareButton>

          <WhatsappShareButton url={url} title={title} separator=": ">
            <WhatsappIcon size={32} round />
          </WhatsappShareButton>

          <LinkedinShareButton url={url}>
            <LinkedinIcon size={32} round />
          </LinkedinShareButton>
        </div>
      )}
    </div>
  );
};

export default ShareObituary;
